import { Component, Inject, Input, OnChanges, SimpleChanges } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { Tools } from "@app/util/tools";
import { Router } from "@angular/router";

declare let Optanon: any;

@Component({
    selector: 'app-web-footer',
    template: require('./webFooter.directive.html')
})
export class WebFooterComponent implements OnChanges {

    @Input() pmcId: string;
    @Input() hoaId: string;
    @Input() propertyId: string;

    firstLoad: boolean;
    footerLogoImageSrc;
    ehlLogoImageSrc;
    fdicLogoImageSrc;
    privacyChoicesImageSrc;
    copyrightYear;

    constructor(@Inject(DomSanitizer) private sanitizer: DomSanitizer,
                @Inject(Tools) public tools: any,
                @Inject(Router) private router: Router) {

        this.firstLoad = this.router.url.includes('guestpayment');

        this.footerLogoImageSrc =
            this.sanitizer.bypassSecurityTrustUrl(require('@res/img/forever-first-web.svg'));
        this.ehlLogoImageSrc =
            this.sanitizer.bypassSecurityTrustUrl(require('@res/img/ehl-white.png'));
        this.fdicLogoImageSrc =
            this.sanitizer.bypassSecurityTrustUrl(require('@res/img/member-fdic-white.png'));
        this.privacyChoicesImageSrc =
            this.sanitizer.bypassSecurityTrustUrl(require('@res/img/privacyoptions.svg'));
        this.copyrightYear = new Date().getFullYear();
    }

    ngOnChanges(changesObj: SimpleChanges): void {
        if (
            (changesObj.pmcId && changesObj.pmcId.currentValue ||
                changesObj.hoaId && changesObj.hoaId.currentValue ||
                changesObj.propertyId && changesObj.propertyId.currentValue) ||
            (!this.firstLoad &&
                (changesObj.hoaId && changesObj.hoaId.previousValue && !changesObj.hoaId.currentValue ||
                    changesObj.pmcId && changesObj.pmcId.previousValue && !changesObj.pmcId.currentValue ||
                    changesObj.propertyId && changesObj.propertyId.previousValue && !changesObj.propertyId.currentValue))
        ) {
            this.pmcId = String(this.pmcId || '')
        } else {
            this.pmcId = null;
        }
        this.firstLoad = false;
    }

    openConsent() {
        if (Optanon) {
            Optanon.ToggleInfoDisplay();
        }
    }
}
